
import aliases from '../assets/icon-aliases.json';
export default {
  props: {

    /**
     * @values icons
     */
    name: {
      /** @type {AlturaIcons} */
      type: String,
      default: 'help-circle'
    },

    /**
     * @values colors
     */
    color: {
      /** @type {AlturaColors} */
      type: String,
      default: undefined
    },

    filled: {
      type: Boolean,
      default: false
    },

    size: {
      type: [String, Number],
      default: undefined
    }
  },

  computed: {
    iconName () {
      if (this.name in aliases) {
        console.warn(`icon '${this.name}' is deprecated. Use '${aliases[this.name]}' instead.`);
        return aliases[this.name];
      }

      return this.name ?? 'help-circle';
    },

    isEmoji () {
      return /^\p{Emoji}+$/u.test(this.name);
    },

    iconSize () {
      if (typeof this.size === 'number') {
        return this.size + 'rem';
      }

      if (/^[0-9.]+$/.test(this.size)) {
        return this.size + 'rem';
      }

      return this.size;
    },

    component () {
      try {
        return require(`../assets/icons/${this.iconName}.svg?inline`);
      } catch {
        return require('../assets/icons/help-circle.svg?inline');
      }
    }
  }
};
